import { useState } from 'react';
import * as vp from 'vopay';
import styles from './InterestAccountModal.module.scss';
import AnnualRatesModal from '../AnnualRatesModal/AnnualRatesModal';
import AddInterestAccountModal from '../AddInterestAccountModal/AddInterestAccountModal';
import { Title } from 'UI';

type InterestAccountProps = {
  visible: boolean;
  currency: string;
  onClose: (added: boolean) => void;
  InterestRates: vp.InterestRate[];
  modifiedInterestRates: vp.InterestRate[];
  currentBalance: string;
  formatAmount: (number: string) => string;
};

const { Box, Button, Modal, Icon } = vp;

const InterestAccountModal: React.FC<InterestAccountProps> = ({
  visible,
  currency,
  onClose,
  InterestRates,
  modifiedInterestRates,
  currentBalance,
  formatAmount,
}) => {
  const [isAnnualRate, setIsAnnualRate] = useState(false);
  const [isAddInterestAccount, setIsAddInterestAccount] = useState(false);

  return (
    <div>
      <Modal isVisible={visible} enableBgClick={false}>
        <div className={styles.container}>
          <Box height="auto" flx="col" ai="center" jc="fe">
            <Box pb="xmd" width="100%">
              <Icon
                width="100%"
                position="right"
                onClick={() => {
                  onClose(false);
                }}
                color="none"
                bgColor="none"
                icon="close2"
                size="sm"
              />
            </Box>
            <Box ps="xmd" pt="smd" pb="smd">
              <Icon width="176px" height="156px" color="none" bgColor="none" icon="interestBank" size="jumbo" />
            </Box>
            <Box pb="smd" className={styles.titleContainer}>
              <Title level="3">Long Term Interest Account</Title>
            </Box>
            <Box pb="smd" ai="fe" className={styles.descriptionContainer}>
              <p>
                Long term accounts let&apos;s you transfer funds from your VoPay Balance for a minimum of 5 days. Once
                the duration is passed, you will start gaining interest.
              </p>
            </Box>

            <Box width="100%" flx="col" gap="sm" jc="fe" pt="smd">
              <Button
                id="create-interest-account-continue"
                label="Continue"
                color="primary"
                type="button"
                borderRadius="10px"
                onClick={() => {
                  setIsAddInterestAccount(true);
                }}
              />

              <Button
                id="create-interest-account-view-rates"
                label="View Interest Rates"
                type="button"
                color="primary-light"
                noShadow
                textColor="#2F82FF"
                onClick={() => {
                  setIsAnnualRate(true);
                }}
              />
            </Box>
          </Box>
        </div>
      </Modal>

      <AnnualRatesModal
        currency={currency}
        InterestRates={InterestRates}
        visible={isAnnualRate}
        onClose={() => setIsAnnualRate(false)}
      />

      <AddInterestAccountModal
        visible={isAddInterestAccount}
        modifiedInterestRates={modifiedInterestRates}
        currency={currency}
        currentBalance={currentBalance}
        formatAmount={formatAmount}
        onClose={(added) => {
          setIsAddInterestAccount(false);

          if (added) {
            onClose(added);
          }
        }}
      />
    </div>
  );
};

export default InterestAccountModal;
